import CroppedPrismicImage from './croppedPrismicImage'

export default CroppedPrismicImage
